import { createAction, createReducer } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  loading: false,
  notifications: [],
};

const notificationsRequest = createAction("notificationsRequest");
const notificationsSuccess = createAction("notificationsSuccess");
const notificationsFailure = createAction("notificationsFailure");

export const notificationsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(notificationsRequest, (state, action) => {
      state.loading = true;
    })
    .addCase(notificationsSuccess, (state, action) => {
      state.loading = false;
      state.notifications = action.payload.notifications;
    })
    .addCase(notificationsFailure, (state, action) => {
      state.loading = false;
    });
});
